var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1816 39.3762C15.791 39.7668 15.791 40.3999 16.1816 40.7904C16.5721 41.181 17.2053 41.181 17.5958 40.7904L25.1178 33.2684L32.6399 40.7904C33.0304 41.181 33.6636 41.181 34.0541 40.7904C34.4446 40.3999 34.4446 39.7668 34.0541 39.3762L26.5321 31.8542L34.0541 24.3321C34.4446 23.9416 34.4446 23.3084 34.0541 22.9179C33.6636 22.5274 33.0304 22.5274 32.6399 22.9179L25.1178 30.44L17.5958 22.9179C17.2053 22.5274 16.5721 22.5274 16.1816 22.9179C15.791 23.3084 15.791 23.9416 16.1816 24.3321L23.7036 31.8542L16.1816 39.3762Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.2292V16.7153V49.6319C1.5 51.9736 3.39674 53.875 5.74306 53.875H44.1458C46.4921 53.875 48.3889 51.9736 48.3889 49.6319V16.7153V11.2292C48.3889 8.88755 46.4921 6.98611 44.1458 6.98611H40.1597V3C40.1597 2.17157 39.4881 1.5 38.6597 1.5C37.8313 1.5 37.1597 2.17157 37.1597 3V6.98611H26.4444V3C26.4444 2.17157 25.7729 1.5 24.9444 1.5C24.116 1.5 23.4444 2.17157 23.4444 3V6.98611H12.7292V3C12.7292 2.17157 12.0576 1.5 11.2292 1.5C10.4007 1.5 9.72917 2.17157 9.72917 3V6.98611H5.74306C3.39674 6.98611 1.5 8.88755 1.5 11.2292Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.43dcd48a5124677c1df339b2f39582ce.svg";
export { ForwardRef as ReactComponent };